import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';
import {EntityLoanViewModel} from '../view-models/entity-loan.view-model';

@Component({
    selector: 'app-entity-loan-card',
    templateUrl: './entity-loan-card.component.html',
    styleUrls: ['./entity-loan-card.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class EntityLoanCardComponent {
    public readonly entityLoan = input.required<EntityLoanViewModel>();
    public readonly cardClicked = output<EntityLoanViewModel>();

    handleClick(_event: Event): void {
        this.cardClicked.emit(this.entityLoan());
    }
}
